import React from 'react';
import BuildGen from '../building/BuildGen';
import ControlCenter from './ControlCenter';
import { BuildingProvider } from '../../context/BuildingContext';
import '../../styles/components/App.css';

const AppContainer = () => {
  return (
    <BuildingProvider>
      <div className="App">
        <main className="App-content">
          <BuildGen />
        </main>
        <div className="ControlCenter-container">
          <ControlCenter />
        </div>
      </div>
    </BuildingProvider>
  );
};

export default AppContainer;